import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";

@Injectable()
export class EquipeResponsabilidadeService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  public getPathModule(): string {
    return '/pre-projeto/equipe-responsabilidade';
  }
}